import useToastSurface from './useToastSurface'

export type { ToastSurface } from './useToastSurface'

export default useToastSurface
